export default __webpack_public_path__ + "static/media/dashboard_clear_hover.b78574fc.svg";